module.exports = __webpack_public_path__ + "img/PGR_A05_back_horizontal_en.bddb147f.png";